import { render, staticRenderFns } from "./MostPopularUsers.vue?vue&type=template&id=40921da3&"
import script from "./MostPopularUsers.vue?vue&type=script&lang=js&"
export * from "./MostPopularUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports